<script>
import { mapGetters } from 'vuex';
import RbxConfirmDialog from '../../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'UserListItem',
  components: {
    RbxConfirmDialog,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.user);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/user/show/${user.id}`">{{ user.username }}</router-link>
    </td>
    <td>{{ user.email }}</td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.surname }}</td>
    <td>
      <v-icon v-if="user.isDelete">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td width="80" align="right">
      <v-tooltip bottom v-if="auth.hasDeleteRights">
        <v-btn @click.native="onDelete" flat icon slot="activator" :disabled="user.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
